import React from 'react';
import { observer } from 'mobx-react';
import { FormControlLabel, Checkbox } from '@material-ui/core';
import * as Styles from './application-information-page.less';
import { FieldState } from 'formstate';
import { Address } from './address';
import { AddressForm } from '../../forms/application-information-forms';

interface IWorkingAddressProps {
    homeAddress: AddressForm;
    workingAddress: AddressForm;
    workingAddressSameAsPrimaryAddress: FieldState<boolean>;
    states: string[];
    validate: (fieldState?: FieldState<string>) => () => Promise<void>;
}

export const WorkingAddress: React.FC<IWorkingAddressProps> = observer(
    ({ homeAddress, workingAddress, workingAddressSameAsPrimaryAddress, states, validate }) => {
        return (
            <>
                <div className={Styles.row}>
                    <div className={Styles.col}>
                        <FormControlLabel
                            control={
                                <Checkbox
                                    className={Styles.radio}
                                    checked={workingAddressSameAsPrimaryAddress.value}
                                    onChange={async (e) => {
                                        workingAddressSameAsPrimaryAddress.onChange(
                                            e.target.checked
                                        );
                                        await validate()();
                                    }}
                                />
                            }
                            label="Work is being performed at this address"
                        />
                    </div>
                </div>
                <Address
                    address={
                        workingAddressSameAsPrimaryAddress.value ? homeAddress : workingAddress
                    }
                    disabled={workingAddressSameAsPrimaryAddress.value}
                    states={states}
                    validate={validate}
                />
            </>
        );
    }
);
